import clsx from 'clsx';
import {memo} from 'react';
interface PrivacyTextProps {
  className?: string;
  darkMode?: boolean;
  actionButtonText: string;
}

export const PrivacyText = memo(({className, darkMode = false, actionButtonText = 'Submit'}: PrivacyTextProps) => {
  return (
    <div className={clsx('text-xs2 pb-4', darkMode ? 'text-gray-200' : 'text-mls-primary', className || '')}>
      *By providing your number and clicking <span className="italic">{actionButtonText}</span>, you agree to receive
      recurring auto-dialed marketing SMS (including AI content; artificial or prerecorded voices) and to our{' '}
      <a
        href="https://www.tocafootball.com/policies/terms-of-service"
        target="_blank"
        rel="noreferrer"
        className={clsx(
          'underline font-medium transition-colors duration-200',
          darkMode ? 'text-blue-500 hover:text-blue-300' : 'text-primary hover:text-primary-dark'
        )}
      >
        Terms of Service
      </a>{' '}
      (including arbitration). Consent not required to purchase. Msg & data rates apply. Msg frequency varies. Reply
      HELP for help; STOP to opt-out. View{' '}
      <a
        href="https://www.tocafootball.com/policies/privacy-policy"
        target="_blank"
        rel="noreferrer"
        className={clsx(
          'underline font-medium transition-colors duration-200 mx-0.5',
          darkMode ? 'text-blue-500 hover:text-blue-300' : 'text-primary hover:text-primary-dark'
        )}
      >
        Privacy Policy
      </a>
      .
    </div>
  );
});

PrivacyText.displayName = 'PrivacyText';
